import * as angular from 'angular';
import * as _ from 'lodash';

import { Group } from '../../models';
import { IValidationPageConfigurationService } from '../../services';

export function getGroup(
    groupGuid: string,
    validationPageConfigurationService: IValidationPageConfigurationService
): angular.IPromise<Group> {

    return validationPageConfigurationService
        .getValidationTreeGroups()
        .then(groups => {
            const found = _.find(groups, g => g.guid === groupGuid);
            return groupGuid && found
                ? found //groupService.getByGuid(groupGuid).then(data => data.group)
                : groups.length > 0 ? groups[0] : undefined;
        });
}